import { LayoutTabSection } from '../../_layouts/LayoutTabSection';
import { TitleText } from '../common/TitleText';
import InfoFillGrayIcon from '@/assets/icons/InfoFillGrayIcon.svg?react';
import { Dialog, DialogTrigger, DialogContent } from '@/components/atoms/Dialog';
import { useFetch, CPLAT_API_ROUTES } from '@/api';
import { AxiosResponse } from 'axios';

import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes';
import { membershipReviewPreviewMarketInfoList } from '../membership-review-inquiry-mock';

type ReviewTutorialMarketInfo = {
  MarketNameEnglish: string;
  MarketIconUrl: string;
};

const TabSection = () => {
  return (
    <LayoutTabSection className="pb-[16px]">
      <div className="flex items-center gap-[16px]">
        <TitleText title="리뷰 관리" />
        <TutorialDialog />
      </div>
    </LayoutTabSection>
  );
};

export default TabSection;

const ENABLE_CHECK_REVIEW = [
  'cafe24',
  'imweb',
  'shopby',
  'ably',
  'idus',
  'zigzag',
  'sixshop',
  'sixshop-pro',
  'alwayz',
  'toss',
];

const ENABLE_COULD_REVIEW = ['cafe24', 'sixshop', 'sixshop-pro'];

const TutorialDialog = () => {
  const isPreviewMode = useMembershipPreviewMode();
  const { data: marketInfoRes, isLoading } = useFetch<AxiosResponse>(
    CPLAT_API_ROUTES.getMarketModel,
    {
      method: 'POST',
      config: {
        enabled: !isPreviewMode,
      },
    },
  );
  const marketInfoList: ReviewTutorialMarketInfo[] = isPreviewMode
    ? membershipReviewPreviewMarketInfoList
    : marketInfoRes?.data || [];
  const shouldShowDialogContent = isPreviewMode || (!isLoading && marketInfoList.length > 0);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          className="flex items-center gap-[2px] rounded-[8px] bg-white px-[10px] py-[6px] "
          data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
        >
          <InfoFillGrayIcon />

          <span className="text-gr-700 Body5M14">이용 방법 확인하기</span>
        </button>
      </DialogTrigger>
      {shouldShowDialogContent && (
        <DialogContent
          className=" w-fit p-[30px]"
          data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
        >
          <div className="flex flex-col gap-[10px]">
            <DialogTopSection marketInfoList={marketInfoList} />
            <DilaogBottomSection marketInfoList={marketInfoList} />
            {!isPreviewMode && <DialogFooterSection />}
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
};

const DialogTopSection = ({ marketInfoList }: { marketInfoList: ReviewTutorialMarketInfo[] }) => {
  return (
    <div className="flex flex-col gap-[10px]">
      <div className="text-gr-800 Title3S18">
        {ENABLE_CHECK_REVIEW.length}개 마켓의 리뷰를 확인할 수 있어요
      </div>
      <div className="flex justify-center gap-[4px] rounded-[10px] bg-gr-50 p-[12px]">
        {ENABLE_CHECK_REVIEW.map((marketName) => {
          const market = marketInfoList.find((item) => item.MarketNameEnglish === marketName);

          return market ? (
            <img
              key={market.MarketIconUrl}
              src={market.MarketIconUrl}
              className="h-[30px] w-[30px]"
              alt={market.MarketNameEnglish}
            />
          ) : null;
        })}
      </div>
      <ul className="custom-bullet-size list-outside list-disc gap-[2px] pl-5 text-gr-500 Caption1M12">
        <li>지원 가능한 마켓은 지속적으로 추가중이에요</li>
        <li>스마트스토어의 경우 셀러박스를 매니저로 등록해야 리뷰 확인 및 답변 작성이 가능해요</li>
      </ul>
    </div>
  );
};

const DilaogBottomSection = ({
  marketInfoList,
}: {
  marketInfoList: ReviewTutorialMarketInfo[];
}) => {
  console.log(ENABLE_COULD_REVIEW);
  return (
    <div className="flex flex-col gap-[12px]">
      <div className="text-gr-800 Title3S18">
        {ENABLE_COULD_REVIEW.length}개 마켓의 리뷰 답변을 작성할 수 있어요
      </div>
      <div className="flex justify-center gap-[4px] rounded-[10px] bg-gr-50 p-[12px]">
        {ENABLE_COULD_REVIEW.map((marketName) => {
          const market = marketInfoList.find((item) => item.MarketNameEnglish === marketName);

          return market ? (
            <img
              key={market.MarketIconUrl}
              src={market.MarketIconUrl}
              className="h-[30px] w-[30px]"
              alt={market.MarketNameEnglish}
            />
          ) : null;
        })}
      </div>
    </div>
  );
};

const DialogFooterSection = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`${ROUTES.marketRegister}/smartstore`);
  };
  return (
    <div className="flex flex-col gap-[8px]">
      <div className="text-gr-800 Body5M14">스마트스토어의 리뷰가 보이지 않나요?</div>
      <button
        onClick={handleClick}
        className="flex w-fit items-center gap-[6px] rounded-[8px] bg-gr-100 px-[10px] py-[6px] text-gr-700 Body5M14"
      >
        확인 방법 <ChevronRight className="h-[16px] w-[16px]" />
      </button>
    </div>
  );
};
